import l10n from "diy/util/l10n";
import websiteData = require("diy/util/websiteData");

import Type from "../definitions/Type";
import {NotificationConfig} from "../definitions/Config";

type XingVouchersData = {
    voucherCode: string;
    landingPageUrl: string;
};

export default {
    type: Type.XING_VOUCHERS,
    testId: "xing-vouchers",
    trackingId: "XingVouchersNotification",

    title: l10n("xingPromo.title"),

    cardOptions: {
        closable: false
    },

    onFactory: (notificationConfig: NotificationConfig) => {
        let xingPromo = websiteData.getNotificationData<XingVouchersData>("xingPromo");

        notificationConfig.content = l10n("xingPromo.content") + "&nbsp;"
            + "<strong>" + xingPromo.voucherCode + "</strong>";

        notificationConfig.mainAction = {
            testId: "xing-redirect",
            label: l10n("xingPromo.label"),
            onClick: () => {
                diy.util.redirector.redirect(xingPromo.landingPageUrl);
            }
        };
        return notificationConfig;
    }

} as NotificationConfig;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/toolbar/notificationNG/types/XingVouchers.ts
 **/